/* eslint-disable @angular-eslint/prefer-inject */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractDataService, LoggerService } from '@pf/shared-services';
import { InventoryAdjustmentsService } from '@control-tower/platform-wms';
import {
    EntityChangeTrackingDto,
    IChangesSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { InventoryAdjustmentStore } from './inventory-adjustment.store';
import {
    InventoryAdjustmentCreate,
    InventoryAdjustmentRead,
    InventoryAdjustmentSearchParams,
} from '../../entities/inventory-adjustment.dto';
import { Operation } from 'fast-json-patch';

@Injectable()
export class InventoryAdjustmentDataService extends AbstractDataService<
    InventoryAdjustmentRead,
    InventoryAdjustmentCreate
> {
    protected EntityName = PFWmsEntities.InventoryAdjustment;
    constructor(
        private service: InventoryAdjustmentsService,
        store: InventoryAdjustmentStore,
        logger: LoggerService
    ) {
        super(store, logger);
    }
    protected createObs$(
        _body: InventoryAdjustmentCreate
    ): Observable<InventoryAdjustmentRead> {
        throw new Error('Cannot create inventory adjustment.');
    }
    protected deleteObs$(_id: string): Observable<InventoryAdjustmentRead> {
        throw new Error('Cannot delete inventory adjustment.');
    }
    protected undoDeleteObs$(_id: string): Observable<InventoryAdjustmentRead> {
        throw new Error('Cannot undo delete inventory adjustment.');
    }
    protected getObs$(id: string): Observable<InventoryAdjustmentRead> {
        return this.service.inventoryAdjustmentReadById({
            id,
        }) as Observable<InventoryAdjustmentRead>;
    }
    protected updateObs$(
        id: string,
        operations: Operation[]
    ): Observable<InventoryAdjustmentRead> {
        return this.service.inventoryAdjustmentUpdatePatch({
            id,
            operation: operations,
        }) as Observable<InventoryAdjustmentRead>;
    }
    protected searchObs$(
        searchParams: InventoryAdjustmentSearchParams
    ): Observable<IPagedResult<InventoryAdjustmentRead>> {
        return this.service.inventoryAdjustmentSearch(
            searchParams
        ) as Observable<IPagedResult<InventoryAdjustmentRead>>;
    }

    protected searchChangesObs$(
        searchParams: IChangesSearchParams
    ): Observable<
        IPagedResult<EntityChangeTrackingDto<InventoryAdjustmentRead>>
    > {
        return this.service.inventoryAdjustmentGetChanges(
            searchParams
        ) as Observable<
            IPagedResult<EntityChangeTrackingDto<InventoryAdjustmentRead>>
        >;
    }
}
